// Shared API error class. Lifted into its own module so both lib/api.ts and
// lib/api/*.ts can import it without circular dependency through the shared
// fetch helpers in _http.ts.

export class ApiClientError extends Error {
	readonly code: string;
	readonly status: number;
	constructor(code: string, message: string, status: number) {
		super(message);
		this.name = "ApiClientError";
		this.code = code;
		this.status = status;
	}
}
